import { render, staticRenderFns } from "./MicrobiologyProgressBar.vue?vue&type=template&id=9e2a44a6&scoped=true"
import script from "./MicrobiologyProgressBar.vue?vue&type=script&lang=js"
export * from "./MicrobiologyProgressBar.vue?vue&type=script&lang=js"
import style0 from "./MicrobiologyProgressBar.vue?vue&type=style&index=0&id=9e2a44a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2a44a6",
  null
  
)

export default component.exports